import moment from 'moment';

// Per IRS Pub 544: holding period begins the day after acquisition.
// Per IRC §1222: long-term = held more than 1 year.
// @see https://www.irs.gov/publications/p550
// @param datePurchased - purchase date, Unix timestamp in milliseconds (ms since epoch)
// @param asOfDate - as-of date, Unix timestamp in milliseconds (ms since epoch)
export const computeHoldingPeriodLabel = (
  datePurchased: number | undefined,
  asOfDate: number | undefined,
): 'Long Term' | 'Short Term' | undefined => {
  if (datePurchased == null || asOfDate == null) {
    return undefined;
  }
  const oneYearFromHoldingStart = moment.utc(datePurchased).add(1, 'day').add(1, 'year');
  return moment.utc(asOfDate).isAfter(oneYearFromHoldingStart) ? 'Long Term' : 'Short Term';
};
